import axiosInstance from "../plugins/axios";
// import scraperjs from "scraperjs"

import Vue from "vue";

export function userInfoService() {

  const fetchUserInfo = async() => {
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_CLIENT}/me`,
    );
  };

  return {
    fetchUserInfo,
  };
}
